import React from 'react';
import './style.less';
import {FormattedMessage} from 'react-intl';

const CookieBannerRender = () => {
  const keyLocalStorage = 'bannerRules';
  const [showBanner, setShowBanner] = React.useState(true)

  const handleClick = () => {
    localStorage.setItem(keyLocalStorage, true);
    setShowBanner(!showBanner)
  };

  const bannerRules = localStorage.getItem(keyLocalStorage);
  if(bannerRules) {
    return null;
  }

  return <section className={showBanner ? 'CookieBanner_cookieBanner CookieBanner_cookieBanner__3fen' : 'close'}>
    <div className="CookieBanner_content__H7">
      <div className="CookieBanner_texts__s">
        <img width="52" height="52" src="/img/gdpr.9eabe203.svg"/>
          <h2 className="CookieBanner_text__sW">
            <FormattedMessage defaultMessage="We use cookies to improve your experience on our websites. By remaining
            on this website and navigating it, you accept the usage of cookies.
            Detailed information about the use of cookies on this website is available " id="GameServer.Cito.Game/CookieBannerText" />
            <a className="CookieBanner_text__a" target="_blank" href="https://cito-training.com/documents">
              <FormattedMessage defaultMessage="here" id="GameServer.Cito.Game/CookieBannerHere" />
            </a>.
          </h2>
        </div>
      <div class="CookieBanner_button__t">
        <button
            className="CookieBanner_button__SsE5D BaseButton_button__cz5q_ WhiteButtonSecondary_button__BeaL0 BaseButton_common__Qs4xl BaseButton_small__sweus BaseButton_button__cz5q_ WhiteButtonSecondary_button__BeaL0"
            type="button" data-testid="baselineButton"
            onClick={handleClick}
        >
          <span className="BaseButton_inner__CAmBg WhiteButtonSecondary_inner__prorn">
            <span className="Common_content__FZ20R"><FormattedMessage defaultMessage="Accept and close" id="GameServer.Cito.Game/CookieBannerButton" /></span>
          </span>
        </button>
      </div>
    </div>
  </section>;
};

export {CookieBannerRender};